// extracted by mini-css-extract-plugin
export default {"contentContainer":"q1ZcbCLVj5z_XJE1h7KE","textItems":"idMAjBtvfuOwnrvGKlWr","video":"RQrwpBQJKGHxDEe9Qe7m"};